import { WSMarginProps, WSTable } from "@wingspanhq/fe-component-library";
import { Batch } from "@wingspanhq/wingspan-api-sdk";
import { ReactNode, useMemo } from "react";

import { getColumns } from "./columns";

type Props = {
  batches: Batch[];
  loading?: boolean;
  bottomMessage?: ReactNode;
  onRowClick?: (batch: Batch) => void;
} & WSMarginProps;

export const TablePayableImportBatches: React.FC<Props> = ({
  batches,
  loading,
  bottomMessage,
  onRowClick,
  ...marginProps
}) => {
  const tableData = useMemo(
    () => batches.map(batch => ({ id: batch.id as string, data: batch })),
    [batches]
  );
  const columns = useMemo(() => getColumns(), []);

  return (
    <WSTable<Batch>
      {...marginProps}
      loading={loading}
      showHeader
      columns={columns}
      tableData={tableData}
      bottomMessage={bottomMessage}
      onRowClick={onRowClick ? rowItem => onRowClick(rowItem.data) : undefined}
    />
  );
};
